const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      conecthubEmbed: {
        title: "Conectar ConectHUB 360",
        webhookHelp:
          "Copie a URL do webhook abaixo e informe no fluxo do ConectHUB / Meta quando for solicitado.",
        openEmbed: "Abrir fluxo ConectHUB",
        embedRunning:
          "Conclua o fluxo na janela do ConectHUB. Ao terminar, a conexão será atualizada automaticamente.",
        close: "Fechar",
        copied: "URL copiada!",
        copyFail: "Não foi possível copiar.",
        payloadRecoveryTitle: "Não foi possível salvar automaticamente",
        payloadRecoveryHelp:
          "O ConectHUB retornou os dados com sucesso, mas o sistema não conseguiu gravar. Copie o JSON abaixo e guarde em um arquivo de texto (Bloco de Notas) para enviar ao suporte ou tentar novamente depois.",
        copyPayload: "Copiar JSON do retorno",
        payloadCopied: "JSON copiado!",
        success: "Conexão WhatsApp Oficial atualizada com sucesso!",
        errors: {
          masterConfig:
            "O administrador precisa configurar o link público e o Account ID do ConectHUB em Configurações → Planos.",
          generic: "Não foi possível iniciar o fluxo.",
          save: "Não foi possível salvar os dados da Meta.",
          embed: "Erro no fluxo do ConectHUB.",
          script: "Não foi possível carregar o script do ConectHUB."
        }
      },
      conecthub360Picker: {
        title: "Escolher Canal",
        subtitle: "Selecione o canal que deseja conectar:",
        whatsappOfficial: "WhatsApp Oficial",
        facebook: "Facebook",
        instagram: "Instagram",
        telegram: "Telegram",
        comingSoon: "EM BREVE",
        planNoWhatsappOfficial:
          "Seu plano não inclui WhatsApp Oficial ou WhatsApp para usar este fluxo.",
        planNoFacebook: "Seu plano não inclui Facebook.",
        planNoInstagram: "Seu plano não inclui Instagram.",
        planNoConecthub360: "Seu plano não inclui ConectHUB 360 para conectar o Telegram por aqui."
      },
      conecthubMeta: {
        titleFacebook: "Facebook (ConectHUB)",
        titleInstagram: "Instagram (ConectHUB)",
        titleTelegram: "Telegram (ConectHUB)",
        hubChannelNoticeTitle: "Integração com o script oficial embed.js",
        hubChannelNoticeBody:
          "O Conect HUB 360 abre o popup em /connect/{canal}/{accountId} (ex.: /connect/facebook/…), como no arquivo embed.js oficial. Informe o webhook e o callback abaixo quando o fluxo do hub pedir.",
        webhookHelp:
          "Use as URLs abaixo no fluxo do ConectHUB quando solicitado. O webhook é o mesmo endpoint que a Meta já utiliza para Facebook e Instagram nativos (POST /webhook).",
        webhookLabel: "Webhook (URL do backend)",
        callbackLabel: "Callback URL",
        telegramHelp:
          "Use o mesmo Account ID e link público do ConectHUB 360 configurados na empresa master (como no painel em Link Direto → Telegram). Não é necessário variáveis novas no .env só para conectar: o fluxo é o embed oficial do hub.",
        telegramDirectLinkLabel: "Link direto Telegram (painel ConectHUB — Link Direto)",
        telegramDirectLinkWithWebhookLabel:
          "Link direto com webhook (recomendado — doc. ConectHUB «Links diretos por canal»)",
        telegramDirectLinkWithWebhookHint:
          "Inclui ?embed=true&webhook_url=… para o hub saber onde enviar as mensagens recebidas ao conectar pelo navegador. Substitua {canal} por telegram na URL: …/connect/telegram/{accountId}.",
        telegramInboundWebhookLabel: "Webhook inbound Telegram (mensagens recebidas)",
        telegramInboundWebhookHelp:
          "Configure esta URL no ConectHUB para o hub enviar mensagens recebidas ao sistema. É diferente do webhook Meta (Facebook/Instagram): use POST …/webhook/telegram-mtproto. A URL deve ser acessível na internet (BACKEND_URL público); localhost não recebe chamadas do hub — use túnel (ngrok, Cloudflare Tunnel) ou servidor em produção.",
        telegramWebhookOptional:
          "Defina BACKEND_URL com a URL pública do backend para gerar o webhook inbound do Telegram. Sem isso, o hub não consegue entregar mensagens ao sistema.",
        successFacebook: "Facebook conectado com sucesso!",
        successInstagram: "Instagram conectado com sucesso!",
        successTelegram: "Telegram conectado com sucesso!",
        errors: {
          masterAccount:
            "Configure o Account ID do ConectHUB na empresa master (Configurações → Planos).",
          backendUrl:
            "Defina BACKEND_URL no servidor (URL pública do backend) para gerar as URLs de webhook e callback.",
          generic: "Não foi possível iniciar o fluxo.",
          save: "Não foi possível salvar a conexão. Verifique os dados retornados pelo ConectHUB.",
          tokenShape:
            "Retorno do ConectHUB sem token de usuário reconhecido. Copie o JSON para o suporte ou confira os nomes dos campos (access_token, user id).",
          popupBlocked: "Permita pop-ups para este site para abrir o ConectHUB."
        }
      },
      telegramBot: {
        title: "Conectar Telegram Bot",
        instructions: "Para conectar o Telegram, você precisa de um Bot Token.",
        instructionsDetail:
          "1. Abra o Telegram e procure @BotFather\n2. Envie /newbot e siga as instruções\n3. Copie o token gerado e cole abaixo",
        nameLabel: "Nome da conexão (opcional)",
        namePlaceholder: "Ex: Atendimento Telegram",
        tokenLabel: "Bot Token",
        tokenHelp: "Formato: 123456789:ABCDefGhIJKlmnOPQrstUVwxyz...",
        tokenRequired: "Informe o token do bot.",
        invalidToken: "Formato do token inválido. Use o token fornecido pelo @BotFather.",
        btnConnect: "Validar e Conectar",
        validating: "Validando token e configurando webhook...",
        success: "Telegram conectado com sucesso!",
        successTitle: "Bot conectado!",
        done: "Concluir",
        cancel: "Cancelar",
        menuLabel: "Telegram Bot (@BotFather)",
        errors: {
          connectFail: "Falha ao conectar o bot do Telegram."
        }
      },
      telegramPersonal: {
        title: "Telegram — conta pessoal",
        menuLabel: "Telegram pessoal (MTProto)",
        help:
          "Conecte sua conta Telegram real (não é bot). Mensagens recebidas nesta conta aparecerão no MultiFlow.",
        phoneLabel: "Número de telefone",
        phoneHint: "Formato internacional com DDI, ex: +5518998020650",
        phoneRequired: "Informe o número de telefone.",
        nameLabel: "Nome da conexão (opcional)",
        sendCode: "Enviar código",
        codeSent: "Código enviado! Verifique o Telegram.",
        codeLabel: "Código de verificação",
        codeRequired: "Informe o código recebido.",
        codeHelp: "Digite o código enviado para {{phone}} no app Telegram.",
        verifyCode: "Confirmar código",
        need2fa: "Esta conta usa verificação em duas etapas (2FA).",
        passwordLabel: "Senha 2FA",
        passwordRequired: "Informe a senha de verificação em duas etapas.",
        passwordHelp: "Informe a senha de verificação em duas etapas do Telegram.",
        verifyPassword: "Confirmar senha",
        success: "Telegram pessoal conectado!",
        cancel: "Cancelar",
        close: "Fechar",
        serverNotConfigured:
          "Servidor sem TELEGRAM_API_ID / TELEGRAM_API_HASH. Configure no .env do backend (my.telegram.org/apps).",
        errors: {
          sendCode: "Falha ao enviar código.",
          verifyCode: "Código inválido ou expirado.",
          verifyPassword: "Senha 2FA inválida."
        }
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        sendPixKey: "Enviar chave PIX",
        sendPixKeySuccess: "Chave PIX enviada no ticket.",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        loadingMessage: "Os dados do Dashboard serão carregados em breve...",
        refreshing: "Atualizando dados...",
        pleaseWait: "Por favor, aguarde",
        refresh: "Atualizar dados",
        filters: "Filtros",
        filter: "FILTRAR",
        general: {
          title: "Informações Gerais",
        },
        overview: {
          title: "Visão Geral e Avaliações",
        },
        activity: {
          title: "Atividade por Período e Desempenho",
          daily: "Atividade Diária",
          perHour: "Atividade por Hora",
        },
        distribution: {
          title: "Distribuição por Canal e Setor",
          byChannel: "Distribuição por Canal",
          byQueue: "Distribuição por Setor",
          channels: "canais",
          channelSingular: "canal",
          queues: "setores",
          queueSingular: "setor",
        },
        hourly: {
          title: "Atividade por Hora",
          peak: "Pico",
          between: "Entre",
          and: "e",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
          weeklyOverview: "Visão Semanal",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
          messages: "Mensagens",
        },
        total: "Total",
        noData: "Sem dados disponíveis",
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "Atendimento",
          averageWaitingTime: "Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
          totalTickets: "Total de Tickets",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuário",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        tickets: {
          overview: "Status dos Tickets",
          timeline: "Timeline de Atendimentos",
          created: "Tickets Criados",
          active: "Tickets ativos atualmente",
          pending: "Tickets aguardando atendimento",
          completed: "Atendimentos concluídos",
          demandActive: "Demanda ativa",
          demandPassive: "Demanda passiva",
          reopened: "Tickets Reabertos",
          inAttendanceTooltip: "Tickets que estão sendo atendidos no momento",
          waitingTooltip: "Tickets que ainda não foram atribuídos a um atendente",
          finalizedTooltip: "Tickets que foram fechados e resolvidos",
          activeTicketsTooltip: "Tickets que foram iniciados pela empresa",
          passiveTicketsTooltip: "Tickets que foram iniciados pelo cliente",
        },
        messages: {
          title: "Mensagens por Período",
          received: "Recebidas",
          sent: "Enviadas",
          total: "Total",
          ratio: "Proporção",
        },
        attendants: {
          performance: "Ranking de Atendentes",
          online: "Online agora",
        },
        topContacts: {
          title: "Ranking de Contatos",
          columns: {
            contact: "Contato",
            tickets: "Tickets",
            queue: "Setor",
            time: "Tempo",
          },
          noData: "Sem contatos para exibir",
          tooltip: "Top 10 contatos com mais tickets abertos no período",
        },
        actions: {
          filter: "Filtrar",
          refresh: "Atualizar",
          fullscreen: "Tela cheia",
          exitFullscreen: "Sair da tela cheia",
        },
        online: "Online agora",
        serviceTime: "Tempo médio de atendimento",
        waitingTime: "Tempo médio de espera na fila",
        newContacts: "Novos contatos no período",
        fromLastMonth: "desde o mês passado",
        newContactsTooltip: "Novos contatos registrados no período selecionado",
        activeAttendantsTooltip: "Número de atendentes disponíveis online",
        timeMetrics: "Métricas de Tempo",
        firstResponseTooltip: "Tempo médio até a primeira resposta do atendente",
        resolutionRateTooltip: "Percentual de tickets resolvidos em relação ao total",
        reopenedTicketsTooltip: "Tickets que foram reabertos após fechamento",
        avgTicketsPerDayTooltip: "Média diária de tickets no período",
        firstResponseTime: "Primeira Resposta",
        sort: {
          ascending: "Crescente",
          descending: "Decrescente",
          orderBy: "Ordenar por",
          tickets: "Número de Tickets",
          rating: "Avaliação",
          waitTime: "Tempo de Espera",
          serviceTime: "Tempo de Atendimento",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
          ratingTooltip: "dos tickets avaliados",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
        filters: {
          title: "Filtros",
          apply: "Filtrar",
          reset: "Limpar Filtros",
          quickFilters: "Filtros Rápidos",
          customRange: "Período Personalizado",
          allTime: "Todo o Período",
          today: "Hoje",
          yesterday: "Ontem",
          last7days: "Últimos 7 dias",
          thisWeek: "Esta semana",
          thisMonth: "Este mês",
          lastMonth: "Mês passado",
          sections: "Visibilidade das Seções",
          refreshInterval: "Intervalo de atualização:",
          refreshManual: "Manual",
          refresh5min: "5 minutos",
          refresh15min: "15 minutos",
          refresh30min: "30 minutos",
          until: "até",
          hideSection: "Ocultar seção",
          showAll: "Mostrar Todas",
          hideAll: "Ocultar Todas",
          advancedTitle: "Filtros avançados",
          advancedHelper:
            "Combine com o período acima. Após escolher fila, conexão, atendente, etc., clique em Filtrar. Atalhos de data mantêm estes critérios.",
          all: "Todas",
          queue: "Fila / setor",
          connection: "Conexão",
          agent: "Atendente",
          channel: "Canal",
          ticketStatus: "Status do atendimento",
          tags: "Tags (com pelo menos uma)",
        },
        ticketStatusFilterValues: {
          open: "Aberto",
          pending: "Pendente",
          closed: "Fechado",
          group: "Grupo",
          chatbot: "Chatbot",
          nps: "NPS",
          lgpd: "LGPD",
        },
      },
      whatsappStatus: {
        title: "Status do WhatsApp",
        subtitle: "Crie e compartilhe seu status no WhatsApp",
        selectAccount: "Selecione a Conta do WhatsApp",
        selectAccountPlaceholder: "Conta do WhatsApp",
        uploadMedia: "Enviar Mídia",
        image: "Imagem",
        video: "Vídeo",
        audio: "Áudio",
        statusText: "Texto do Status",
        statusTextPlaceholder: "Escreva seu status aqui...",
        backgroundColor: "Cor de Fundo",
        scheduleForLater: "Agendar para depois",
        date: "Data",
        time: "Hora",
        repeat: "Repetir",
        noRepeat: "Não repetir",
        daily: "Diário",
        weekly: "Semanal",
        monthly: "Mensal",
        endDate: "Data de término",
        scheduleStatus: "Agendar Status",
        sendStatus: "Enviar Status",
        cancelSchedule: "Cancelar agendamento",
        cancelScheduleButton: "Cancelar",
        cancelScheduleTitle: "Cancelar agendamento",
        cancelScheduleMessage: "Deseja cancelar este status agendado? Ele não será publicado no horário programado.",
        scheduledFor: "Agendado para",
        sending: "Enviando...",
        previousStatuses: "Status Anteriores",
        republish: "Republicar",
        delete: "Apagar",
        deleteTitle: "Apagar status",
        deleteMessage: "Apagar este status também no WhatsApp (celular)? Ele será removido do histórico do painel.",
        deleteHint: "Tenta apagar o story no WhatsApp; pode falhar se já expirou (24h) ou for registro antigo",
        sent: "Enviado",
        failed: "Falhou",
        scheduled: "Agendado",
        pending: "Pendente",
        cancelled: "Cancelado",
        noStatuses: "Nenhum status anterior encontrado",
        preview: "Pré-visualização do Status",
        myStatus: "Meu Status",
        justNow: "Agora mesmo",
        replyToStatus: "Responder ao status...",
        previewPlaceholder: "Seu status aparecerá aqui",
        progress: {
          title: "Publicando status",
          completedTitle: "Status publicado!",
          errorTitle: "Falha na publicação",
          starting: "Iniciando postagem do status...",
          wait: "Aguarde, estamos processando seu status...",
          waitButton: "Aguarde...",
          closeButton: "Fechar",
        },
        toasts: {
          success: "Status enviado com sucesso!",
          scheduled: "Status agendado com sucesso!",
          republished: "Status republicado com sucesso!",
          deleted: "Status apagado com sucesso",
          deleteError: "Erro ao remover status",
          error: "Erro ao enviar status",
          selectWhatsapp: "Selecione um WhatsApp",
          addContent: "Digite um texto ou selecione uma mídia",
          fileTooLarge: "Arquivo muito grande. Tamanho máximo:",
          noPermission: "Você não tem permissão para acessar esta página",
          cancelled: "Agendamento cancelado com sucesso!",
          cancelError: "Erro ao cancelar agendamento",
        },
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            kanban: "Kanban",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        online: "Online",
        offline: "Offline",
        warning: "Atenção",
        check: "Verificar",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
          clone: "Clonar conexao",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
          receiveComments: "Receber Comentários",
        },
        inboundOnlyBadge: "Só recebe",
        receiveComments: {
          enabled: "Recebimento de comentários habilitado",
          disabled: "Recebimento de comentários desabilitado",
          tooltip: {
            enabled: "Comentários estão sendo recebidos. Clique para desabilitar.",
            disabled: "Comentários não estão sendo recebidos. Clique para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
        reusedTicketToast:
          "Já existe um atendimento para este contato nesta conexão. Abrindo o ticket…",
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          inboundOnly: "Apenas receptiva (bloquear 1.º envio)",
          inboundOnlyHelper:
            "Quando ativado, os atendentes não podem abrir um novo atendimento nem enviar a primeira mensagem por esta conexão. O canal continua recebendo mensagens e o atendente responde em tickets já abertos (cliente escreveu primeiro) ou após o fluxo natural de entrada.",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio (opcional)",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          triggerIntegrationOnCloseMode: "Ação",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          triggerIntegrationOnCloseModeAsk: "Perguntar",
          triggerIntegrationOnCloseModeTrigger: "Disparar",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
        modalTitle: "Etapas para acessar",
        step1: "Abra o WhatsApp no seu celular",
        step2:
          "Toque em Mais opções (Android) ou Configurações (iPhone)",
        step3:
          "Selecione \"Dispositivos conectados\" e depois \"Conectar dispositivo\"",
        step4: "Escaneie este QR code para confirmar",
        hintBelowQr:
          "Aponte a câmera do seu celular para esta tela para capturar o código",
        remainingTime: "Tempo restante",
        expireSoon:
          "O código expira em poucos segundos. Se não conseguir escanear, solicite um novo QR.",
        expiredHint:
          "Este código pode ter expirado. Solicite um novo QR CODE na lista de conexões.",
        waiting: "Gerando código...",
        close: "Fechar",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
        bulkTags: {
          title: "Adicionar tags",
          description: "Adicionar tags nos contatos selecionados (sem remover as existentes)",
          placeholder: "Selecione ou digite as tags",
          apply: "Adicionar tags",
          success: "Tags adicionadas com sucesso!",
          noContacts: "Selecione pelo menos um contato",
          noTags: "Selecione pelo menos uma tag",
          button: "Adicionar tags",
          selectPageOnly: "Selecione contatos na página para adicionar tags",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          delay: "Delay da IA (segundos)",
          delayHelp: "Aguarda este tempo antes de responder (agrupa sequência de mensagens do contato). Padrão: 7",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
        exportExcel: "Exportar para Excel",
        exportSuccess: "Planilha exportada com sucesso!",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          flowId: "Fluxo ao entrar na fila",
          flowIdDisabled: "Desabilitado",
          flowIdHelper:
            "Quando o ticket for atribuído a esta fila (menu ou transferência), o fluxo selecionado será iniciado automaticamente.",
          fileListId: "Lista de arquivos",
          promptTalkAi: "Prompt Talk AI",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          queueTypeButton: "Botão",
          queueTypeList: "Lista",
          buttonTextLabel: "Texto do botão",
          buttonTextPlaceholder: "Ex.: Vendas, Suporte, Sair",
          buttonTextHelper: "No WhatsApp o texto do botão tem limite de 20 caracteres.",
          listOptionLabel: "Texto da opção da lista",
          listOptionPlaceholder: "Digite o texto que aparecerá nesta opção",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          googleCalendar: "Google Calendar",
          googleClientId: "Client ID (Google Cloud)",
          googleClientSecret: "Client Secret",
          googleClientSecretHintEdit:
            "Carregado ao editar (somente para sua sessão). Salvar sem mudar o secret mantém o OAuth. Troque o valor só se for rotacionar no Google Cloud — aí será preciso conectar de novo.",
          googleClientSecretHintNew:
            "Obrigatório na primeira vez. Veja em Google Cloud → Credenciais → seu cliente OAuth.",
          googleCalendarId: "ID da agenda (ex.: primary)",
          googleCalendarIdManualHint:
            "Use o ID técnico da agenda (ex.: primary ou e-mail). Depois de conectar, prefira a lista abaixo.",
          googleCalendarReadCalendars: "Incluir nas consultas da IA",
          googleCalendarWriteCalendar: "Agenda para criar novos eventos",
          googleCalendarRefreshList: "Atualizar lista de agendas",
          googleCalendarListHint:
            "Marque quais agendas a IA pode listar. Cada evento na listagem indica a agenda (cal=) para exclusão correta.",
          googleCalendarEmptyList:
            "Nenhuma agenda retornada. Verifique o escopo OAuth (reconecte se acabou de atualizar o sistema) ou tente «Atualizar lista».",
          googleCalendarPrimaryBadge: "principal",
          googleCalendarNotInListSuffix: "valor salvo; não na lista",
          googleCalendarOrphanBadge: "salvo; fora da lista atual",
          googleTimeZone: "Fuso horário (IANA)",
          googleOAuthHint:
            "Salve o projeto com Client ID e Secret. Depois use «Conectar com Google» para concluir o OAuth. O redirect deve ser o exibido abaixo (Google Cloud Console).",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
          connectGoogle: "Conectar com Google",
          googleCalendarConnectedBadge: "Conectado ao Google Calendar",
          googleCalendarConnectedAt: "Confirmado em",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
          googleCalendarConnected: "Google Calendar conectado com sucesso.",
          googleCalendarError: "Não foi possível concluir o OAuth do Google Calendar.",
          googleCalendarSelectCalendars:
            "Marque pelo menos uma agenda para consulta (ou mantenha a seleção atual).",
        },
        googleCalendarHelp: {
          aria: "Ajuda: conectar Google Calendar",
          title: "Conectar o Google Calendar",
          linkCloudConsole: "Google Cloud Console",
          linkCalendarApi: "API Google Calendar",
          linkCredentials: "Credenciais (OAuth)",
          linkRedirectDoc: "Redirect URI — documentação Google",
          linkAccountPermissions: "Apps com acesso à conta Google",
          linkFlowBuilder: "Flow Builder",
          step1a: "Acesse o",
          step1b: ", crie ou selecione um projeto.",
          step1c: "Ative a",
          step1d: "Em",
          step1e: ", crie um ID de cliente OAuth do tipo",
          step1f: "Aplicativo da Web",
          step2a:
            "No cliente OAuth, em «URIs de redirecionamento autorizados», inclua exatamente o endereço exibido abaixo neste formulário (termina em",
          step2b: ").",
          step2c: "Guia oficial:",
          step3a:
            "Informe Client ID e Client Secret, salve e use «Conectar com Google». Se não obtiver acesso, revogue o app em",
          step3b: "e tente de novo.",
          step4a: "Abra o",
          step4b: ", edite um fluxo com bloco GPT ou Gemini e, em Google Calendar, selecione esta integração.",
          copyRedirectUri: "Copiar URL de redirect",
          copyRedirectUriSuccess: "URL copiada para a área de transferência.",
          copyRedirectUriError: "Não foi possível copiar. Copie manualmente.",
          copyRedirectUriEmpty: "URL de redirect indisponível. Configure REACT_APP_BACKEND_URL ou salve a integração.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          workHours: "Horários de Atendimento",
          workHoursHelper: "Configure os horários de atendimento para cada dia da semana. Você pode adicionar múltiplos períodos por dia.",
          addPeriod: "Adicionar Período",
          whatsapp: "Conexões permitidas",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver automações",
          allowWhatsappStatus: "Postar Status",
          allowTransferTicket: "Transferir Ticket",
          enabled: "Habilitado",
          disabled: "Desabilitado",
          enableAllPermissions: "Habilitar tudo",
        },
        tabs: {
          general: "Geral",
          workHours: "Horários de Trabalho",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
          layoutType: "Tipo de Layout",
          layoutClassic: "Layout Clássico (Menu Lateral)",
          layoutModern: "Layout Moderno (Menu Horizontal)",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          view: "Detalhes do agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
          oficialTemplate: "Template reserva (janela fechada)",
          oficialTemplateHelper:
            "Se no horário do envio a janela de 24h estiver aberta, envia o texto livre. Se estiver fechada, envia este template aprovado na Meta.",
          oficialBodyHelper:
            "Texto livre: enviado quando a janela de 24h estiver aberta no momento do disparo.",
          oficialEmptyTemplates: "Nenhum template aprovado encontrado para esta conexão",
          oficialTemplateLoading: "Carregando templates…",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAllTicketsDescription: "Tem certeza que deseja fechar todos os tickets visíveis com os filtros aplicados? Tickets fora do filtro não serão fechados.",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
          filtersApplied: "Filtros Aplicados",
          clearFilters: "Limpar Filtros",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        fieldConnectionLabel: "Conexão de Destino",
        fieldConnectionDefault: "Manter conexão atual",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        closedHeader: "Resolvidos",
        flowHeader: "Flow",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        sortUnreadFirst: "Não lidos primeiro",
        sortByDate: "Por data",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
        actions: {
          newTicket: "Novo ticket",
          search: "Busca",
          showMyTickets: "Mostrar meus tickets",
          showAll: "Mostrar todos",
          openFilters: "Abrir Filtros",
          closeFilters: "Fechar Filtros",
          closeAllTickets: "Fechar todos os tickets",
          searchButton: "Buscar",
          clearSearch: "Limpar Pesquisa",
          searchInMessages: "Pesquisar no conteúdo das mensagens",
          appliedFilters: "Filtros Aplicados",
          clearAllFilters: "Limpar todos os filtros",
          clearFilters: "Limpar Filtros",
          clear: "Limpar",
          newAttendance: "Novo Atendimento",
          resolved: "Resolvidos",
          newestFirst: "Mais recentes primeiro",
          oldestFirst: "Mais antigos primeiro",
          selectTicket: "Selecionar Ticket",
          attendances: "Atendimentos",
        },
        ticketMessageSearchModal: {
          title: "Mensagens neste atendimento",
          resultsSuffix: "resultado(s) neste ticket",
          empty: "Nenhuma mensagem encontrada neste atendimento.",
          close: "Fechar",
          you: "Você",
          contactUnknown: "Contato não identificado",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          dashboardTags: "Dashboard de Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          apisSubmenu: "APIs",
          messagesAPI: "API",
          apiOficialDocs: "API Oficial",
          testInteractive: "Testar botões/lista",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          automations: "Automações",
          auditLogs: "Logs de Auditoria",
          groupManagement: "Gestão de Grupos",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          language: "Idioma",
          theme: {
            light: "Modo Claro",
            dark: "Modo Escuro",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      apiOficialDocs: {
        title: "API Oficial WhatsApp (Meta)",
        intro: "Documentação para envio de mensagens via WhatsApp Business API da Meta. Use o token da conexão WhatsApp Oficial em todas as requisições.",
        baseUrl: "URL base",
        auth: "Autenticação",
        authDesc: "Todas as requisições requerem o header Authorization com o token da conexão WhatsApp Oficial (campo token da conexão).",
        authHeader: "Header:",
        endpoints: "Endpoints disponíveis",
        postmanTitle: "Collection Postman",
        postmanDesc: "Baixe a collection completa para importar no Postman e testar todas as rotas.",
        downloadPostman: "Baixar collection Postman",
        notesTitle: "Observações",
        note1: "Mensagens normais (texto, imagem, áudio, vídeo, documento) requerem janela de 24h ativa.",
        note2: "Templates podem ser enviados a qualquer momento, sem janela de 24h.",
        note3: "O número deve ser enviado sem máscara (ex: 5511999998888).",
        sections: {
          send: "Envio de mensagens",
          media: "Upload e mídia",
          templates: "Templates",
          verification: "Verificação",
        },
        endpointsDesc: {
          sendText: "Enviar mensagem de texto.",
          sendImage: "Enviar imagem (arquivo, URL ou mediaId).",
          sendAudio: "Enviar áudio.",
          sendVideo: "Enviar vídeo.",
          sendDocument: "Enviar documento.",
          sendTemplate: "Enviar template (não requer janela de 24h).",
          uploadMedia: "Upload de mídia para Meta (retorna media_id).",
          mediaLimits: "Retorna limites de mídia por tipo.",
          listTemplates: "Listar templates aprovados.",
          validateTemplate: "Validar template antes do envio.",
          checkWindow: "Verificar se número está na janela de 24h.",
        },
        examplesTitle: "Exemplos de requisição",
        exampleSendText: "Enviar texto",
        exampleSendTemplate: "Enviar template",
        exampleGetTemplates: "Listar templates",
        testTitle: "Testar na tela",
        testDesc: "Preencha o token da conexão WhatsApp Oficial e opcionalmente número/body. Clique em Enviar para executar a requisição.",
        testEndpoint: "Endpoint",
        testToken: "Token (obrigatório)",
        testNumber: "Número (ex: 5511999998888)",
        testBody: "Body (JSON)",
        testSend: "Enviar",
        testResponse: "Resposta",
        testStatus: "Status",
        testLoading: "Enviando...",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
        transferTitle: "Chamado transferido:",
        transferReceived: "Você recebeu um chamado transferido",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        filterPlaceholder: "Digite para filtrar pelo nome do fluxo...",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        noOptions: "Nenhum fluxo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        errors: {
          mediaNotFound:
            "O anexo da resposta rápida{{shortcode}} não foi encontrado. O arquivo pode ter sido corrompido ou removido. Edite a resposta rápida e envie o anexo novamente.",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        laneTicketCountTooltip: "Tickets nesta coluna: {{count}}",
        laneTicketCountAria: "{{count}} tickets nesta coluna",
        laneTicketCountFilteredTooltip: "Exibindo {{filtered}} de {{total}} tickets nesta coluna",
        laneTicketCountFilteredAria: "{{filtered}} de {{total}} tickets nesta coluna",
        laneSearchTooltip: "Filtrar por nome ou número do contato",
        laneSearchAria: "Pesquisar contato nesta coluna",
        laneSearchPlaceholder: "Nome ou número do contato",
        laneSearchClearAria: "Limpar pesquisa",
        laneSearchNoResults: "Nenhum contato encontrado nesta coluna",
        assignValue: "Atribuir valor",
        removeAssignedValue: "Remover valor atribuído",
        filterByUser: "Filtrar por Usuário",
        filterByConnection: "Filtrar por Conexão",
        filterAll: "Todos",
        showClosed: "Ver fechados",
        ticketClosed: "Fechado",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
        showingCardsPartial: "Exibindo {{visible}} de {{total}} cards (carregue mais para ver os demais).",
        loadMoreCards: "Carregar mais cards",
      },

      campaignsPro: {
        title: "Campanhas PRO",
        searchPlaceholder: "Pesquisa",
        tabs: {
          campaigns: "Campanhas",
          contactLists: "Listas de Contatos",
        },
        import: {
          title: "Importar Contatos",
          steps: {
            upload: "Upload",
            mapping: "Mapear Colunas",
            result: "Resultado",
          },
          fields: {
            name: "Nome do Contato",
            number: "Número de Telefone (obrigatório)",
            var1: "Variável 1 (personalização)",
            var2: "Variável 2 (personalização)",
            var3: "Variável 3 (personalização)",
            var4: "Variável 4 (personalização)",
            var5: "Variável 5 (personalização)",
            var6: "Variável 6 (personalização)",
            tags: "Tags",
            optedIn: "Opted-in",
          },
          options: {
            listName: "Nome da Lista",
            optIn: "Marcar todos como autorizados (opt-in)",
            allowDuplicates: "Permitir números duplicados",
            confirmAuth: "Confirmo que tenho autorização para contatar estas pessoas",
          },
          result: {
            success: "Importação Concluída!",
            imported: "Importados",
            duplicates: "Duplicados",
            invalid: "Inválidos",
          },
          buttons: {
            import: "Importar Contatos",
            viewContacts: "Ver Meus Contatos",
            importMore: "Importar Mais",
          },
        },
        variables: {
          title: "Variáveis disponíveis (clique para inserir)",
          name: "nome",
          phone: "telefone",
          var1: "var1",
          var2: "var2",
          var3: "var3",
          var4: "var4",
          var5: "var5",
          var6: "var6",
        },
        buttons: {
          newCampaign: "Nova Campanha PRO",
          importContacts: "Importar Contatos",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
          imported: "Contatos importados com sucesso",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        delivered: "Entregue",
        pending: "Pendente",
        failed: "Falha",
        unknown: "Desconhecido",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
        fetchError: "Erro ao buscar dados do relatório",
        backButton: "Voltar",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      whatsappSelect: {
        inputLabel: "Conexões permitidas",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
          exportExcel: "Baixar Excel",
        },
        searchPlaceholder: "Pesquisar...",
        kanbanLane: "Kanban",
        kanbanLaneAll: "Todas as lanes",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
        invoices: {
          column: "Faturas",
          view: "Ver faturas",
          title: "Faturas da empresa",
          empty: "Nenhuma fatura cadastrada.",
          detail: "Detalhes",
          value: "Valor",
          dueDate: "Vencimento",
          status: "Status",
          close: "Fechar",
          cancel: "Cancelar",
          editTitle: "Editar fatura",
          deleteTitle: "Excluir fatura",
          deleteMessage:
            "A fatura será removida do sistema. Se houver cobrança vinculada no gateway ativo, ela também será cancelada.",
          deleteGatewayHint:
            "Esta fatura possui cobrança no gateway — será cancelada automaticamente (Asaas, Mercado Pago ou Gerencianet).",
          deleteAsaasHint:
            "Esta fatura possui cobrança no Asaas — ela será cancelada automaticamente.",
          toasts: {
            updated: "Fatura atualizada com sucesso.",
            deleted: "Fatura excluída com sucesso.",
            deletedAsaas: "Fatura excluída e cobrança removida no Asaas.",
          },
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          groupManagement: "Gestão de Grupos",
          whatsappMeow: "WhatsMeow (WuzAPI)",
          conecthub360: "Conecthub 360",
          useTelegram: "Telegram",
          telegramSetupTitle: "Telegram — configuração do servidor (usuário master)",
          telegramSetupBody:
            "1) Crie um app em my.telegram.org/apps e configure no .env do backend: TELEGRAM_API_ID e TELEGRAM_API_HASH (válido para toda a instalação). Reinicie o backend (PM2) após salvar.\n2) Neste plano, habilite «Telegram» para liberar as conexões em Conexões.\n3) Bot (@BotFather): cada bot usa token próprio — não precisa das variáveis acima.\n4) Conta pessoal (MTProto): Conexões → Telegram pessoal — usa as variáveis do .env.",
          telegramPlanHint: "Libera Bot @BotFather e conta pessoal (MTProto) neste plano.",
          conecthubOpen: "Abrir ConectHUB",
          conecthubPublicLink: "Link público do ConectHUB 360",
          conecthubPublicLinkSave: "Salvar link",
          conecthubPublicLinkToastOk: "Configurações ConectHUB salvas na empresa master.",
          conecthubPublicLinkToastErr: "Não foi possível salvar as configurações do ConectHUB.",
          conecthubAccountId: "Account ID (ConectHUB)",
          conecthubMessagingApiKey: "API Key (mensageria ConectHUB)",
          conecthubMessagingApiKeyHint:
            "Chave para POST na API de mensagens do hub (header X-API-Key). Apenas na empresa master.",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
          phraseListFlow: "Fluxo de campanha (listas)",
          conversationFlow: "Fluxo de conversa (flowbuilder)",
          followUpFlow: "Follow UP (templates)",
          phraseListFlowShort: "Fl. campanha",
          conversationFlowShort: "Fl. conversa",
          followUpFlowShort: "Follow UP",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      holidays: {
        title: "Feriados Recorrentes",
        infoText: "Feriados recorrentes - válidos para qualquer ano. Quando uma mensagem for recebida em um dia de feriado ativo, a descrição do feriado será enviada automaticamente.",
        table: {
          dayMonth: "Dia/Mês",
          description: "Descrição",
          status: "Status",
          statusActive: "Ativo",
          statusInactive: "Inativo",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar",
        },
        modal: {
          createTitle: "Novo Feriado",
          editTitle: "Editar Feriado",
          month: "Mês",
          day: "Dia",
          description: "Descrição do Feriado",
          descriptionPlaceholder: "Ex: Dia da Independência do Brasil",
          isActive: "Feriado Ativo",
          save: "Salvar",
          create: "Criar",
          cancel: "Cancelar",
          infoText: "Este feriado será válido para qualquer ano (2025, 2026, 2027...)",
        },
        confirmationModal: {
          deleteTitle: "Excluir Feriado",
          deleteMessage: "Deseja realmente excluir o feriado",
        },
        toasts: {
          created: "Feriado criado com sucesso!",
          updated: "Feriado atualizado com sucesso!",
          deleted: "Feriado excluído com sucesso!",
        },
        empty: "Nenhum feriado cadastrado",
      },
      groupManagement: {
        title: "Gestão de Grupos WhatsApp",
        selectConnection: "Selecione a conexão",
        listGroups: "Listar grupos",
        listGroupsDescription: "Ver todos os grupos da conexão",
        createGroup: "Criar grupo",
        createGroupDescription: "Criar novo grupo e adicionar participantes",
        broadcast: "Envio em massa",
        broadcastDescription: "Enviar mensagem para vários grupos",
        editGroup: "Editar grupo",
        editGroupDescription: "Alterar dados e participantes de grupos em que você é admin",
        editGroupAdminOnlyHint: "Listados apenas os grupos em que este número é administrador.",
        editGroupListHint: "Listados os grupos desta conexão. Apenas grupos em que este número é administrador permitem edição.",
        tabGroupInfo: "Informações do grupo",
        noAdminGroups: "Nenhum grupo em que você seja administrador.",
        saveGroup: "Salvar alterações",
        groupUpdated: "Grupo atualizado com sucesso.",
        editGroupParticipants: "Adicionar ou remover participantes",
        noConnections: "Nenhuma conexão disponível",
        noConnectionsTitle: "Nenhuma conexão com gestão de grupos",
        noConnectionsHint: "Conecte um WhatsApp (Baileys ou WhatsMeow) para usar a gestão de grupos.",
        back: "Voltar",
        groupName: "Nome do grupo",
        groupNamePlaceholder: "Ex: Meu Grupo",
        groupDescription: "Descrição do grupo",
        groupDescriptionPlaceholder: "Texto que aparece na página de informações do grupo (opcional)",
        groupCoverPhoto: "Foto de capa",
        addCoverPhoto: "Clique ou arraste uma imagem",
        changeCoverPhoto: "Clique para trocar a foto de capa",
        currentCover: "Capa atual",
        removeCover: "Remover capa",
        coverMustBeImage: "Selecione um arquivo de imagem (JPG, PNG, etc.).",
        participantsCount: "Participantes",
        actions: "Ações",
        seeParticipants: "Ver participantes",
        leaveGroup: "Sair do grupo",
        leaveGroupConfirm: "Sair do grupo \"{{name}}\"? Você deixará de receber mensagens.",
        leaveGroupOthersRemain: "Os outros participantes continuarão no grupo. No WhatsApp não é possível excluir o grupo para todos.",
        deleteGroup: "Excluir grupo",
        deleteGroupTitle: "Excluir grupo",
        deleteGroupConfirmMessage: "Para confirmar a exclusão do grupo \"{{name}}\", digite EXCLUIR abaixo.",
        deleteGroupTypePlaceholder: "Digite EXCLUIR",
        deleteGroupConfirmWord: "EXCLUIR",
        noGroups: "Nenhum grupo encontrado.",
        participants: "Participantes",
        nameRequired: "Informe o nome do grupo.",
        groupCreated: "Grupo criado com sucesso.",
        create: "Criar",
        participantName: "Nome",
        participantNumber: "Número",
        admin: "Admin",
        noParticipants: "Nenhum participante.",
        addParticipant: "Adicionar",
        removeParticipant: "Remover participante",
        participantNumberRequired: "Informe o número do participante.",
        participantAdded: "Participante adicionado.",
        participantRemoved: "Participante removido.",
        removeSelected: "Remover selecionados",
        participantsRemoved: "{{count}} participante(s) removido(s).",
        selectAtLeastOneParticipant: "Selecione ao menos um participante.",
        generateCampaign: "Gerar campanha",
        listFromGroup: "Lista do Grupo",
        chooseCampaignType: "Escolha o tipo de campanha",
        chooseCampaignTypeHint: "Será criada uma lista em Campanhas PRO com os contatos selecionados. Depois, abra a campanha desejada.",
        campaignPro: "Campanha PRO",
        campaignOfficial: "Campanha Oficial",
        creatingList: "Criando lista...",
        creatingListHint: "Adicionando contatos à lista. Aguarde.",
        exportCsv: "Exportar CSV",
        normalizingTitle: "Normalizando participantes",
        normalizingProgress: "Resolvendo nomes e números dos contatos. Isso pode levar até 1 minuto.",
        validatingContactCount: "Validando contato {{current}} de {{total}}",
        importMapping: "Importar mapeamento",
        importMappingTitle: "Mapeamento LID → Nome/Número",
        importMappingHint: "Cole um CSV com colunas: lid;numero;nome (uma linha por participante). LID é o ID que aparece na lista quando o número não é conhecido.",
        importMappingPlaceholder: "Ex.: 68899982856277;5511999999999;João Silva",
        importMappingSuccess: "Mapeamento importado: {{created}} novos, {{updated}} atualizados.",
        importMappingError: "Erro ao importar mapeamento.",
        cancel: "Cancelar",
        selectGroupsToSend: "Selecione os grupos para enviar a mensagem",
        selectAll: "Selecionar todos",
        searchGroups: "Pesquisar por nome",
        message: "Mensagem",
        sendBroadcast: "Enviar",
        attachMedia: "Anexar mídia",
        sendMedia: "Enviar mídia",
        mediaImage: "Imagem",
        mediaVideo: "Vídeo",
        mediaAudio: "Áudio",
        mediaDocument: "Documento",
        removeMedia: "Remover mídia",
        messageCaptionHint: "Opcional: legenda para a mídia",
        messageOrMediaRequired: "Informe o texto e/ou anexe uma mídia (imagem, áudio ou PDF).",
        results: "Resultado por grupo",
        previewTitle: "Preview em tempo real",
        previewEmpty: "Digite sua mensagem para ver o preview",
        leftGroup: "Você saiu do grupo.",
        selectGroupsAndMessage: "Selecione ao menos um grupo e escreva a mensagem.",
        broadcastSent: "Enviado: {{count}} de {{total}} grupos.",
        groupSettings: "Configurações",
        settingAnnouncement: "Somente admins enviam",
        settingAnnouncementHint: "Quando ativado, apenas administradores podem enviar mensagens.",
        settingLocked: "Restringir edição",
        settingLockedHint: "Quando ativado, apenas administradores podem editar dados do grupo.",
        settingUpdated: "Configuração atualizada com sucesso.",
        member: "Membro",
        superadmin: "Super Admin",
        role: "Cargo",
        promote: "Promover a Admin",
        promoted: "Participante promovido a admin.",
        demote: "Rebaixar a Membro",
        demoted: "Participante rebaixado a membro.",
        inviteLink: "Link de convite",
        generateInviteLink: "Gerar link de convite",
        copyInviteLink: "Copiar link de convite",
        inviteLinkCopied: "Link de convite copiado!",
        inviteLinkError: "Erro ao gerar link de convite.",
        totalGroups: "Total de grupos",
        selected: "selecionado(s)",
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          layout: "Layout",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
        },
        layout: {
          title: "Layout do Sistema",
          description: "Escolha o estilo de layout que prefere para o sistema. O layout moderno oferece uma navegação mais rápida com menu horizontal.",
          save: "Salvar e Aplicar",
          classic: {
            title: "Layout Clássico",
            description: "Menu lateral tradicional, ideal para quem prefere navegação vertical.",
          },
          modern: {
            title: "Layout Moderno",
            description: "Menu horizontal no topo, design moderno e navegação mais rápida.",
          },
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            ask: "Perguntar",
            askGreetingConfirm: "Deseja enviar a mensagem de saudação?",
            updating: "Atualizando...",
            open: "Aberto",
            pending: "Pendente",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            chatBotTypeText: "Texto",
            chatBotTypeButton: "Botões",
            chatBotTypeList: "Lista",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            transferredTicketStatus:
              "Status do ticket ao transferir com usuário",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            notifyOnTransfer:
              "Notificar em transferências",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_",
            removeCountryCodeOnCopy: "REMOVER CODIGO DE PAIS?",
            removeAreaCodeOnCopy: "REMOVER CODIGO DE AREA ?",
            remove9thDigitOnCopy: "REMOVER 9° DIGITO?"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        messageFailed: "Falha ao enviar mensagem.",
        baileysAccountRestricted:
          "Conexão {{name}}: conta restrita pelo WhatsApp. Verifique o app no celular desta conexão.",
        baileysAccountRestrictedGeneric:
          "Conta restrita pelo WhatsApp. Verifique o app no celular da conexão.",
        scrollToBottom: "Ir para a última mensagem",
        scrollToQuoted: "Ir à mensagem original",
        searchScrollNotFound:
          "Não foi possível localizar esta mensagem na conversa atual (histórico muito antigo ou mensagem removida).",
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        searchScrollWrongTicket:
          "Esta mensagem é de outro atendimento. Abra o ticket correspondente para ver o trecho no histórico.",
        searchScrollNoUuid:
          "Não foi possível abrir o outro atendimento (identificador do ticket ausente).",
        searchScrollStorageError:
          "Não foi possível preparar a navegação. Verifique se o armazenamento do navegador está liberado.",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
          scheduledMessages: "Mensagens agendadas",
        },
        extraInfo: "Outras informações",
        scheduledMessages: {
          title: "Mensagens agendadas",
          pending: "Agendadas",
          sent: "Enviadas",
          sentLabel: "ENVIADA",
          noPending: "Nenhuma mensagem agendada para este contato.",
          noSent: "Nenhuma mensagem agendada já enviada.",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        closeTicket: "Encerrar ticket",
        conversar: "Conversar",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
        camera: {
          tabPhoto: "Foto",
          tabVideo: "Gravar vídeo",
          preparing: "Preparando câmera…",
          startRecord: "Iniciar gravação",
          stopSend: "Parar e enviar",
          accessError: "Não foi possível usar a câmera. Verifique permissões do navegador.",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
        officialApiNoEditDelete: "Na API Oficial do WhatsApp não é possível apagar ou editar mensagens. A alteração vale apenas no sistema.",
        officialApiNoReactions:
          "Este canal (API Oficial do WhatsApp) não aceita reações com emoji.",
        channelNoReactions: "Este canal não aceita reações com emoji.",
        editModal: {
          title: "Editar mensagem",
          edited: "Editada",
          placeholder: "Digite a mensagem",
          confirm: "Confirmar edição",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_OFFICIAL_NO_REACTIONS:
          "Este canal (API Oficial do WhatsApp) não aceita reações com emoji.",
        ERR_CHANNEL_NO_REACTIONS: "Este canal não aceita reações com emoji.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Usuário ou Senha inválida",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_SENDING_FACEBOOK_MSG:
          "Erro ao enviar mensagem pelo Facebook/Instagram. Tente novamente.",
        ERR_FACEBOOK_24H_WINDOW_CLOSED:
          "A janela de 24 horas para responder foi encerrada. De acordo com as políticas da Meta, você só pode enviar mensagens dentro de 24h após a última mensagem do cliente. Aguarde o próximo contato do cliente para responder.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        "Limite de armazenamento excedido": "Limite de armazenamento excedido",
        "Limite de armazenamento atingido": "Limite de armazenamento atingido",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_INBOUND_ONLY_NO_OUTBOUND:
          "Esta conexão está em modo “apenas receptivo”: não é possível abrir um novo atendimento ou enviar a primeira mensagem. Aguarde o contato escrever ou use outra conexão.",
        ERR_CANNOT_DELETE_SUPER_ADMIN: "Não é permitido excluir o usuário super administrador.",
        ERR_CANNOT_DELETE_MAIN_COMPANY: "Não é permitido excluir a empresa principal do sistema.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_UNABLE_TO_BLOCK_CONTACT:
          "Não foi possível bloquear o contato. Verifique se a conexão com o WhatsApp está online e se o número é válido.",
        ERR_UNABLE_TO_UNBLOCK_CONTACT:
          "Não foi possível desbloquear o contato. Verifique se a conexão com o WhatsApp está online.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
        viewTicket: "Acessar Ticket",
      },
      dashboardTags: {
        title: "Dashboard de Tags",
        unreadOnly: "Não lidos",
        showAll: "Ver todos",
        onlyOpenPending: "Apenas Ticket Aberto/Pendente",
        refresh: "Atualizar",
        showingOf: "de",
        viewContent: "Ver conteúdo",
        ticketContent: "Conteúdo do ticket",
        lastMessage: "Última mensagem",
        close: "Fechar",
        openTicket: "Acessar ticket",
        queue: "Fila",
        user: "Usuário",
        editContact: "Editar contato",
      },
      campaignsPhrase: {
        searchCampaign: "Pesquisar campanha…",
        noSearchResults: "Nenhuma campanha corresponde à pesquisa.",
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        modal: {
          title: "Criar grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
      whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        changelogUrl: "Link do Drive de Logs de Updates",
        changelogUrlHelper: "Link do Google Docs com as atualizações do sistema",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        loginVideoYoutube: "Link do Vídeo do YouTube (Login)",
        loginVideoYoutubeHelper: "O vídeo aparecerá embutido sobre o fundo da página de login",
        loginVideoPosition: "Posição do vídeo na tela",
        videoPosition: {
          "top-left": "Superior esquerdo",
          "top-right": "Superior direito",
          "bottom-left": "Inferior esquerdo",
          "bottom-right": "Inferior direito",
        },
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
    },
  },
};

export { messages };
